

















import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import Enumerable from "linq";
import { ModelEditableMixin } from "../../../../base/components/system/mixins";
import EditableFormatSummaryFilter from "./EditableFormatSummaryFilter.vue";
import EditableFormatSummaryMasterCodeFilter from "./EditableFormatSummaryMasterCodeFilter.vue";
import { EditableFormatSummaryFilterParameter } from ".";

@Component({
  components: {
    EditableFormatSummaryFilter,
    EditableFormatSummaryMasterCodeFilter,
  },
})
export default class DeletedEditableFormatSummaryFilter extends Mixins(ModelEditableMixin) {
  readPropertyOrDefault: <T>(reader: (source: EditableFormatSummaryFilterParameter) => T, defaultValue: T) => T;
  writeProperty: (writer: (source: EditableFormatSummaryFilterParameter) => void) => void;
  editingSource: EditableFormatSummaryFilterParameter;

  @Prop({ default: false })
  expand: boolean;

  activeNames: string[] = [];
  updatedMasterCode: string = "";

  mounted(): void {
    this.updateActiveNames();
  }

  private updateActiveNames(): void {
    this.activeNames = this.expand
      ? ["1"]
      : [];
  }

  get conditionsString(): string {
    const text = Enumerable.from([
      this.formatNameConditionString,
      this.masterCodeConditionString,
    ])
    .where(t => !!t)
    .toArray()
    .join("");
    return "絞り込み：" + (text ? text : "なし");
  }

  private formatConditionString(name: string, value: string): string {
    return value
      ? (name + "【" + value + "】")
      : "";
  }

  get formatNameConditionString(): string {
    return this.formatConditionString(
      this.$wording.format.name + "名称",
      this.readPropertyOrDefault(s => s.name.keyword, null));
  }

  get masterCodeConditionString(): string {
    return this.formatConditionString(
      "整理番号",
      this.updatedMasterCode);
  }

  @Watch("expand")
  onExpandUpdated(newValue: boolean, oldValue: boolean): void {
    this.updateActiveNames();
  }

  clear(): void {
    this.editingSource = new EditableFormatSummaryFilterParameter("", null, "", "", true, true);
  }
}
